// src/admin/AdminDashboard.js
// Ce fichier est le conteneur principal de l'espace administrateur.
// Il structure la mise en page (Sidebar fixe + Zone de contenu dynamique) et gère le routing interne de l'admin.

import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';

// ✅ IMPORT DES VRAIS FICHIERS (Basé sur ta capture d'écran)
import AdminOverview from './AdminOverview'; // Ton Tableau de bord principal
import UsersPage from './UsersPage';         // Ta gestion utilisateurs
import QuotasPage from './QuotasPage';       // Tes quotas
import DomainsPage from './DomainsPage';     // Tes domaines
import PaymentsPage from './PaymentsPage';   // Tes paiements
import StatsPage from './StatsPage';         // Tes stats
import SettingsPage from './SettingsPage';   // Tes paramètres
import ReportsPage from './ReportsPage';   // Pré-rapports

const AdminDashboard = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-full bg-gray-100">
            
            {/* Sidebar de gauche */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

            {/* Zone de contenu principale */}
            <div className="flex-1 flex flex-col overflow-hidden">
                
                {/* Contenu dynamique */}
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-6">
                    
                    <Routes>
                        {/* 1. Redirection par défaut : /admin -> /admin/dashboard */}
                        <Route path="/" element={<Navigate to="dashboard" replace />} />

                        {/* 2. Tableau de bord (J'utilise AdminOverview, change pour StatsPage si tu préfères) */}
                        <Route path="dashboard" element={<AdminOverview />} />

                        {/* 3. Utilisateurs */}
                        <Route path="users" element={<UsersPage />} />

                        {/* 4. Quotas */}
                        <Route path="quotas" element={<QuotasPage />} />

                        {/* 5. Domaines */}
                        <Route path="domains" element={<DomainsPage />} />

                        {/* 6. Paiements */}
                        <Route path="payments" element={<PaymentsPage />} />

                        {/* 7. Pré-rapports */}
                        <Route path="reports" element={<ReportsPage />} />

                        {/* 8. Statistiques */}
                        <Route path="stats" element={<StatsPage />} />

                        {/* 8. Paramètres */}
                        <Route path="settings" element={<SettingsPage />} />

                        {/* 404 Interne si la page n'existe pas */}
                        <Route path="*" element={
                            <div className="flex items-center justify-center h-full text-gray-500">
                                Page en construction ou introuvable.
                            </div>
                        } />
                    </Routes>

                </main>
            </div>
        </div>
    );
};

export default AdminDashboard;